<template>
    <div
        id="nav-betslip"
        :class="['betslip', { fixed: $store.state.betSlip.active === 'dailyLotto' }]"
        :style="{
            'min-height': height,
        }"
    >
        <div class="betslip__body">
            <div class="betslip__tab" v-if="$store.state.betSlip.isNav">
                <template v-for="(nav, index) in tab.list" :key="index">
                    <div
                        v-if="nav.isShow"
                        :class="['betslip__tab-item', { active: nav.key === $store.state.betSlip.active }]"
                        @click="onChangeTabGame(nav)"
                    >
                        {{ getTranslatedText(nav.label) }}
                        <span class="betslip__tab__quantity">
                            {{ renderQuantityCart(nav.key) }}
                        </span>
                    </div>
                </template>
            </div>
            <Lotto v-if="$store.state.betSlip.active === 'okapiLottery'" @continue-paying="$emit('continue-paying')" />
            <DailyLotto
                v-if="$store.state.betSlip.active === 'dailyLotto'"
                @continue-paying="$emit('continue-paying')"
            />
            <InstantLotto
                v-if="$store.state.betSlip.active === LOTTO_INSTANT.SLUG_GAME"
                @continue-paying="$emit('continue-paying')"
            />
        </div>
    </div>
    <Reprint />
</template>
<script>
import { mapState } from 'vuex';

import languageMixins from '@/mixins/language-mixins';
import functionMixins from '@/mixins/function-utils';
import printMixins from '@/mixins/print-mixins';

import Lotto from '@/components/betslip/partials/lotto.vue';
import DailyLotto from '@/components/betslip/partials/daily-lotto.vue';
import InstantLotto from '@/components/betslip/partials/instant.vue';
import Reprint from '@/components/common/dialog/reprint.vue';
import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto';

export default {
    mixins: [languageMixins, functionMixins, printMixins],
    components: { Lotto, DailyLotto, Reprint, InstantLotto },
    data() {
        return {
            height: '500px',
            tab: {
                list: [
                    {
                        key: 'okapiLottery',
                        label: 'okapi lottery',
                        isShow: this.$store.state.betSlip.okapiLottery,
                    },
                    {
                        key: 'dailyLotto',
                        label: 'daily Lotto',
                        isShow: this.$store.state.betSlip.dailyLotto,
                    },
                    {
                        key: LOTTO_INSTANT.SLUG_GAME,
                        label: LOTTO_INSTANT.GAME_TITLE,
                        isShow: this.$store.state.betSlip.instantLotto,
                    },
                ],
            },
            LOTTO_INSTANT,
        };
    },
    computed: {
        ...mapState(['ModulesDailyLotto', 'ModulesInstantLotto']),
    },

    created() {
        this.setHeightBetSlip();
        window.addEventListener('resize', this.setHeightBetSlip);
    },

    methods: {
        setHeightBetSlip() {
            const nav = document.getElementById('navigation');
            let height = nav?.clientHeight || 0;
            height = window.innerHeight - height;
            this.height = `${height}px`;
        },

        renderQuantityCart(type) {
            switch (type) {
                case 'okapiLottery':
                    return this.$store.state.cart.quantity;
                case 'dailyLotto':
                    return this.ModulesDailyLotto.totalDaily;
                case LOTTO_INSTANT.SLUG_GAME:
                    return this.ModulesInstantLotto.totalInstant;
                default:
                    break;
            }
        },

        onChangeTabGame(nav) {
            this.$store.dispatch('setTabActive', nav.key);
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/betslip/betslip.scss';
</style>
